(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscription-builder-wizard"] && !Shopify.designMode) return;
  try {
    

(function () {
  'use strict';

  const STEPS = ['quantity', 'interval', 'coffee-style', 'grind', 'notes'];

  class SubscriptionBuilderWizard {
    constructor(container) {
      this.container = container;
      this.form = container.querySelector('.sub-builder__form');
      this.submitBtn = container.querySelector('[data-submit-btn]');
      this.errorsWrap = container.querySelector('[data-errors]');
      this.errorsList = container.querySelector('[data-errors-list]');
      this.coffeeGrid = container.querySelector('[data-coffee-grid]');
      this.coffeeGridWrap = container.querySelector('[data-coffee-grid-wrap]');
      this.coffeeEmptyEl = container.querySelector('[data-coffee-empty]');
      this.recommendationEl = container.querySelector('[data-recommendation]');
      this.coffeeCards = [];
      this.collectionHandle = container.dataset.collectionHandle;

      this.mobileDrawer = container.querySelector('[data-mobile-drawer]');
      this.drawerContent = container.querySelector('[data-drawer-content]');
      this.drawerToggle = container.querySelector('[data-drawer-toggle]');

      this.activeStep = STEPS[0];
      this.completedSteps = new Set();

      this.state = {
        variantId: null,
        variantLabel: null,
        variantPrice: null,
        sellingPlanId: null,
        sellingPlanLabel: null,
        brewStyle: 'all',
        includeDecaf: false,
        includeBuzzlite: false,
        selectionMode: 'dealers-choice',
        selectedCoffees: [],
        grind: null,
        notes: ''
      };

      if (this.submitBtn) {
        this.submitBtn.dataset.originalLabel = this.submitBtn.textContent.trim();
      }

      this._bindEvents();
      this._loadCoffees();
      this._updateSummary();
      this._updateMobileProgress();
      this._initMobileDrawer();
    }

    // ── Event binding ──────────────────────────────────────────────

    _bindEvents() {
      this.container.addEventListener('change', (e) => {
        const t = e.target;

        if (t.name === 'sub-variant') {
          this.state.variantId = t.value;
          this.state.variantPrice = t.dataset.priceFormatted || null;
          const lbl = this.container.querySelector(`label[for="${t.id}"] .sub-builder__qty-title`);
          this.state.variantLabel = lbl ? lbl.textContent.trim() : null;
          this._clearStepError('quantity');
          this._updateSummary();
        }

        if (t.name === 'sub-selling-plan') {
          this.state.sellingPlanId = t.value;
          const lbl = this.container.querySelector(`label[for="${t.id}"] .opt-label__text`);
          this.state.sellingPlanLabel = lbl ? lbl.textContent.trim() : null;
          this._clearStepError('interval');
          this._updateSummary();
        }

        if (t.name === 'sub-brew-style') {
          this.state.brewStyle = t.value;
          this._updateSummary();
        }

        if (t.dataset.caffeineToggle === 'decaf') {
          this.state.includeDecaf = t.checked;
          this._toggleRecommendation();
          this._updateSummary();
        }

        if (t.dataset.caffeineToggle === 'buzzlite') {
          this.state.includeBuzzlite = t.checked;
          this._toggleRecommendation();
          this._updateSummary();
        }

        if (t.name === 'sub-selection-mode') {
          this.state.selectionMode = t.value;
          this._toggleCoffeeGrid();
          this._clearStepError('coffee-style');
          this._updateSummary();
        }

        if (t.name === 'sub-grind') {
          this.state.grind = t.value;
          this._clearStepError('grind');
          this._updateSummary();
        }
      });

      // Notes
      const notesInput = this.container.querySelector('[name="sub-notes"]');
      if (notesInput) {
        notesInput.addEventListener('input', (e) => {
          this.state.notes = e.target.value;
        });
      }

      // Coffee cards — click and keyboard
      if (this.coffeeGrid) {
        this.coffeeGrid.addEventListener('click', (e) => {
          const card = e.target.closest('.sub-builder__coffee-card');
          if (card) this._toggleCoffeeCard(card);
        });

        this.coffeeGrid.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            const card = e.target.closest('.sub-builder__coffee-card');
            if (card) {
              e.preventDefault();
              this._toggleCoffeeCard(card);
            }
          }
        });
      }

      // Next / Change / Submit — direct listeners, bypass theme event delegation
      this.container.querySelectorAll('[data-next-step]').forEach((btn) => {
        btn.addEventListener('click', () => this._handleNext(btn.dataset.nextStep));
      });

      this.container.querySelectorAll('[data-step-change]').forEach((btn) => {
        btn.addEventListener('click', () => this._handleChange(btn.dataset.stepChange));
      });

      const submitBtn = this.container.querySelector('[data-submit-btn]');
      if (submitBtn) {
        submitBtn.addEventListener('click', () => this._handleSubmit());
      }
    }

    // ── Mobile drawer ───────────────────────────────────────────────

    _initMobileDrawer() {
      if (!this.drawerToggle || !this.drawerContent) return;

      this.drawerToggle.addEventListener('click', () => {
        const isExpanded = this.drawerToggle.getAttribute('aria-expanded') === 'true';
        this._setDrawerExpanded(!isExpanded);
      });

      // Hide drawer when the submit area scrolls into view
      const submitWrap = this.container.querySelector('[data-step="submit"]');
      if (submitWrap && window.IntersectionObserver) {
        const obs = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (this.mobileDrawer) {
                this.mobileDrawer.classList.toggle('sub-builder__mobile-drawer--hidden', entry.isIntersecting);
                // Collapse the drawer when it hides so it opens fresh next time
                if (entry.isIntersecting) this._setDrawerExpanded(false);
              }
            });
          },
          { threshold: 0.1 }
        );
        obs.observe(submitWrap);
      }
    }

    _setDrawerExpanded(expanded) {
      if (!this.drawerToggle || !this.drawerContent) return;
      this.drawerToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      this.drawerContent.hidden = !expanded;
    }

    // ── Step machine ───────────────────────────────────────────────

    _handleNext(targetStep) {
      const current = this.activeStep;
      const error = this._validateStep(current);

      if (error) {
        this._showStepError(current, error);
        return;
      }

      const proceed = () => {
        this._markComplete(current, this._stepSummaryText(current));

        // Clean up grid inline styles now — body is hidden so no flash
        if (this.coffeeGridWrap) {
          this.coffeeGridWrap.style.cssText = '';
        }

        // Settle delay: lets collapsed content adjust page height before scroll measurement
        setTimeout(() => {
          if (targetStep === 'submit') {
            const submitWrap = this.container.querySelector('[data-step="submit"]');
            if (submitWrap) this._scrollTo(submitWrap);
            this._updateMobileProgress();
          } else {
            const nextStepEl = this.container.querySelector(`[data-step="${targetStep}"]`);
            this._scrollTo(nextStepEl).then(() => {
              this._openStep(targetStep, { scroll: false });
              this._updateMobileProgress();
            });
          }
        }, 200);
      };

      // If the coffee grid is visible: scroll up to step header, then close, then proceed
      if (this.coffeeGridWrap && !this.coffeeGridWrap.hidden) {
        const grid = this.coffeeGridWrap;
        const currentStepEl = this.container.querySelector(`[data-step="${current}"]`);

        // Step 1: scroll "Your coffee style" to top of screen (tight gap, quicker 500ms)
        this._scrollTo(currentStepEl, 500, 20).then(() => {

          // Step 2: grid slides up
          grid.style.maxHeight = grid.scrollHeight + 'px';
          grid.style.opacity = '1';
          grid.getBoundingClientRect(); // force reflow
          grid.style.transition = 'max-height 350ms ease-in, opacity 280ms ease, margin-top 350ms ease, margin-bottom 350ms ease';
          grid.style.maxHeight = '0';
          grid.style.opacity = '0';
          grid.style.marginTop = '0';
          grid.style.marginBottom = '0';

          setTimeout(() => {
            // Step 3: normal markComplete + open next step
            this._markComplete(current, this._stepSummaryText(current));
            if (this.coffeeGridWrap) this.coffeeGridWrap.style.cssText = '';

            setTimeout(() => {
              if (targetStep === 'submit') {
                const submitWrap = this.container.querySelector('[data-step="submit"]');
                if (submitWrap) this._scrollTo(submitWrap);
                this._updateMobileProgress();
              } else {
                this._openStep(targetStep);
                this._updateMobileProgress();
              }
            }, 150);
          }, 360);
        });
      } else {
        proceed();
      }
    }

    _handleChange(stepName) {
      // Collapse the currently active step without marking it complete
      if (this.activeStep && this.activeStep !== stepName) {
        const activeEl = this.container.querySelector(`[data-step="${this.activeStep}"]`);
        if (activeEl) {
          const body = activeEl.querySelector(`[data-step-body="${this.activeStep}"]`);
          if (body) body.hidden = true;
          // Keep its existing state (completed or upcoming)
        }
      }
      this._openStep(stepName);
      this._updateMobileProgress();
    }

    _openStep(name, { scroll = true } = {}) {
      const step = this.container.querySelector(`[data-step="${name}"]`);
      if (!step) return;

      const body = step.querySelector(`[data-step-body="${name}"]`);
      if (body) body.hidden = false;

      step.dataset.stepState = 'active';
      this.activeStep = name;

      if (scroll) this._scrollTo(step);

      // Move focus to first focusable element inside the body
      if (body) {
        const firstFocusable = body.querySelector('input, button, textarea, [tabindex="0"]');
        if (firstFocusable) {
          // Small delay so scroll completes before focus fires
          setTimeout(() => firstFocusable.focus({ preventScroll: true }), 300);
        }
      }
    }

    _markComplete(name, summaryText) {
      const step = this.container.querySelector(`[data-step="${name}"]`);
      if (!step) return;

      const body = step.querySelector(`[data-step-body="${name}"]`);
      const summaryEl = step.querySelector(`[data-step-summary="${name}"]`);
      const changeBtn = step.querySelector(`[data-step-change="${name}"]`);

      if (body) body.hidden = true;
      if (summaryEl) summaryEl.textContent = summaryText || '—';
      if (changeBtn) changeBtn.hidden = false;

      step.dataset.stepState = 'completed';
      this.completedSteps.add(name);
    }

    _validateStep(name) {
      const s = this.state;
      switch (name) {
        case 'quantity':
          return s.variantId ? null : 'Please select a quantity.';
        case 'interval':
          return s.sellingPlanId ? null : 'Please select a delivery frequency.';
        case 'coffee-style':
          if (s.selectionMode === 'pick' && s.selectedCoffees.length === 0) {
            return 'Pick at least one coffee for your rotation.';
          }
          return null;
        case 'grind':
          return s.grind ? null : 'Please select a grind option.';
        case 'notes':
          return null;
        default:
          return null;
      }
    }

    _stepSummaryText(name) {
      const s = this.state;
      switch (name) {
        case 'quantity':
          return s.variantLabel || '—';
        case 'interval':
          return s.sellingPlanLabel || '—';
        case 'coffee-style': {
          const brew = s.brewStyle === 'all' ? 'All' : s.brewStyle.charAt(0).toUpperCase() + s.brewStyle.slice(1);
          if (s.selectionMode === 'dealers-choice') {
            return `${brew} · Dealer's Choice`;
          } else {
            const n = s.selectedCoffees.length;
            return `${brew} · ${n} coffee${n !== 1 ? 's' : ''}`;
          }
        }
        case 'grind':
          return s.grind || '—';
        case 'notes': {
          const t = (s.notes || '').trim();
          if (!t) return 'None';
          return t.length > 40 ? t.slice(0, 37) + '…' : t;
        }
        default:
          return '—';
      }
    }

    // ── Step error messages ────────────────────────────────────────

    _showStepError(stepName, message) {
      const el = this.container.querySelector(`[data-step-error="${stepName}"]`);
      if (!el) return;
      el.textContent = message;
      el.hidden = false;
    }

    _clearStepError(stepName) {
      const el = this.container.querySelector(`[data-step-error="${stepName}"]`);
      if (el) el.hidden = true;
    }

    // ── Coffee loading (AJAX) ──────────────────────────────────────

    async _loadCoffees() {
      const loadingEl = this.coffeeGrid && this.coffeeGrid.querySelector('[data-coffee-loading]');
      console.log('[SubBuilder] _loadCoffees — handle:', this.collectionHandle);

      if (!this.collectionHandle) {
        if (loadingEl) loadingEl.textContent = 'No collection configured.';
        return;
      }
      if (!this.coffeeGrid) return;

      try {
        const products = await this._fetchCollectionProducts(this.collectionHandle);
        console.log('[SubBuilder] fetched products:', products.length);
        const coffees = products.filter(p =>
          (Array.isArray(p.tags) ? p.tags : p.tags.split(',').map(t => t.trim())).includes('Coffee-Sub')
        );

        if (loadingEl) loadingEl.remove();

        coffees.forEach(product => {
          this.coffeeGrid.appendChild(this._buildCoffeeCard(product));
        });

        this.coffeeCards = Array.from(this.coffeeGrid.querySelectorAll('.sub-builder__coffee-card'));
        this._updateSummary();
      } catch (err) {
        console.error('[SubBuilder] Failed to load coffees:', err);
        if (loadingEl) loadingEl.textContent = 'Failed to load coffees. Please refresh the page.';
      }
    }

    async _fetchCollectionProducts(handle) {
      const products = [];
      let page = 1;
      let hasMore = true;

      while (hasMore) {
        const res = await fetch(`/collections/${handle}/products.json?limit=250&page=${page}`);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        products.push(...data.products);
        hasMore = data.products.length === 250;
        page++;
      }

      return products;
    }

    _buildCoffeeCard(product) {
      const tags = Array.isArray(product.tags) ? product.tags : product.tags.split(',').map(t => t.trim());

      const brewParts = [];
      if (tags.includes('Filter')) brewParts.push('filter');
      if (tags.includes('Espresso')) brewParts.push('espresso');

      let caffeineType = 'regular';
      if (tags.includes('Decaf')) caffeineType = 'decaf';
      else if (tags.includes('Buzzlite')) caffeineType = 'buzzlite';

      const img = product.images && product.images[0];
      const imgSrc = img ? this._shopifyImageUrl(img.src, 300) : null;
      const imgAlt = this._escapeHtml(img && img.alt ? img.alt : product.title);

      const card = document.createElement('div');
      card.className = 'sub-builder__coffee-card';
      card.dataset.brewStyles = brewParts.join(',');
      card.dataset.caffeineType = caffeineType;
      card.dataset.handle = product.handle;
      card.dataset.title = product.title;
      card.setAttribute('role', 'checkbox');
      card.setAttribute('aria-checked', 'false');
      card.setAttribute('tabindex', '0');

      card.innerHTML = `
        ${imgSrc ? `<div class="sub-builder__coffee-img"><img src="${imgSrc}" alt="${imgAlt}" width="300" loading="lazy"></div>` : ''}
        <div class="sub-builder__coffee-info">
          <span class="sub-builder__coffee-name">${this._escapeHtml(product.title)}</span>
        </div>
        <span class="sub-builder__coffee-check" aria-hidden="true">✓</span>
      `;

      return card;
    }

    _shopifyImageUrl(src, width) {
      return src.replace(/\.(jpg|jpeg|png|gif|webp)(\?|$)/i, `_${width}x.$1$2`);
    }

    _escapeHtml(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    // ── Coffee card selection ──────────────────────────────────────

    _toggleCoffeeCard(card) {
      const handle = card.dataset.handle;
      if (this.state.selectedCoffees.includes(handle)) {
        this._deselectCoffee(card);
      } else {
        this._selectCoffee(card);
      }
      this._clearStepError('coffee-style');
      this._updateSummary();
    }

    _selectCoffee(card) {
      card.setAttribute('aria-checked', 'true');
      const handle = card.dataset.handle;
      if (!this.state.selectedCoffees.includes(handle)) {
        this.state.selectedCoffees.push(handle);
      }
    }

    _deselectCoffee(card) {
      card.setAttribute('aria-checked', 'false');
      const handle = card.dataset.handle;
      this.state.selectedCoffees = this.state.selectedCoffees.filter(h => h !== handle);
    }

    // ── Recommendation message ─────────────────────────────────────

    _toggleRecommendation() {
      if (!this.recommendationEl) return;
      this.recommendationEl.hidden = !(this.state.includeDecaf || this.state.includeBuzzlite);
    }

    // ── Coffee grid visibility ─────────────────────────────────────

    _toggleCoffeeGrid() {
      if (!this.coffeeGridWrap) return;
      this.coffeeGridWrap.hidden = this.state.selectionMode !== 'pick';
    }

    // ── Summary ────────────────────────────────────────────────────

    _updateSummary() {
      const s = this.state;

      this._setSummaryRow('quantity', s.variantLabel);
      this._setDrawerRow('quantity', s.variantLabel);
      this._setSummaryRow('interval', s.sellingPlanLabel);
      this._setDrawerRow('interval', s.sellingPlanLabel);

      // Only populate brew-style and mode once step 3 is active or completed
      if (this.completedSteps.has('coffee-style') || this.activeStep === 'coffee-style') {
        const brewLabel = s.brewStyle === 'all' ? 'All' : s.brewStyle.charAt(0).toUpperCase() + s.brewStyle.slice(1);
        this._setSummaryRow('brew-style', brewLabel);
        this._setDrawerRow('brew-style', brewLabel);
        if (s.selectionMode === 'dealers-choice') {
          this._setSummaryRow('mode', "Dealer's Choice");
          this._setDrawerRow('mode', "Dealer's Choice");
        } else {
          const count = s.selectedCoffees.length;
          this._setSummaryRow('mode', count > 0 ? `${count} selected` : null);
          this._setDrawerRow('mode', count > 0 ? `${count} selected` : null);
        }
      } else {
        this._setSummaryRow('brew-style', null);
        this._setDrawerRow('brew-style', null);
        this._setSummaryRow('mode', null);
        this._setDrawerRow('mode', null);
      }

      this._setSummaryRow('grind', s.grind);
      this._setDrawerRow('grind', s.grind);

      const cafPrefs = [];
      if (s.includeDecaf) cafPrefs.push('Decaf');
      if (s.includeBuzzlite) cafPrefs.push('Buzzlite');
      this._setSummaryRow('decaf-buzzlite', cafPrefs.length ? cafPrefs.join(', ') : null);
      this._setDrawerRow('decaf-buzzlite', cafPrefs.length ? cafPrefs.join(', ') : null);

      // Price — desktop panel
      const priceValEl = this.container.querySelector('[data-summary-price-value]');
      const priceRowEl = this.container.querySelector('[data-summary-price]');
      if (priceValEl) {
        priceValEl.textContent = s.variantPrice || '—';
        if (priceRowEl) priceRowEl.classList.toggle('sub-builder__summary-price--empty', !s.variantPrice);
      }

      // Price — mobile drawer (expanded content + collapsed pill)
      const drawerPriceValEl = this.container.querySelector('[data-drawer-price-value]');
      const drawerPriceRowEl = this.container.querySelector('[data-drawer-price-row]');
      const drawerPillPriceEl = this.container.querySelector('[data-drawer-price]');
      if (drawerPriceValEl) {
        drawerPriceValEl.textContent = s.variantPrice || '—';
        if (drawerPriceRowEl) drawerPriceRowEl.classList.toggle('sub-builder__drawer-price--empty', !s.variantPrice);
      }
      if (drawerPillPriceEl) {
        drawerPillPriceEl.textContent = s.variantPrice || '—';
      }

      this._updateMobileProgress();
    }

    _setSummaryRow(key, value) {
      const row = this.container.querySelector(`[data-summary-row="${key}"]`);
      const val = this.container.querySelector(`[data-summary-value="${key}"]`);
      if (!val) return;
      val.textContent = value || '—';
      if (row) row.classList.toggle('sub-builder__summary-row--empty', !value);
    }

    _setDrawerRow(key, value) {
      const row = this.container.querySelector(`[data-drawer-row="${key}"]`);
      const val = this.container.querySelector(`[data-drawer-value="${key}"]`);
      if (!val) return;
      val.textContent = value || '—';
      if (row) row.classList.toggle('sub-builder__drawer-row--empty', !value);
    }

    // ── Mobile progress ────────────────────────────────────────────

    _updateMobileProgress() {
      const stepEl = this.container.querySelector('[data-mobile-step]');
      const priceEl = this.container.querySelector('[data-mobile-price]');
      if (stepEl) {
        const idx = STEPS.indexOf(this.activeStep);
        const stepNum = idx >= 0 ? idx + 1 : STEPS.length;
        stepEl.textContent = `Step ${stepNum} of ${STEPS.length}`;
      }
      if (priceEl) {
        priceEl.textContent = this.state.variantPrice || '—';
      }
    }

    // ── Scroll ─────────────────────────────────────────────────────

    _getStickyOffset() {
      const header = document.querySelector('#pageheader');
      return header ? header.getBoundingClientRect().height : 0;
    }

    _scrollTo(el, duration = 700, gap = 80) {
      const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const stickyOffset = this._getStickyOffset();
      const targetY = Math.max(0, el.getBoundingClientRect().top + window.pageYOffset - stickyOffset - gap);

      if (prefersReduced) {
        window.scrollTo({ top: targetY, behavior: 'auto' });
        return Promise.resolve();
      }

      // Cancel any in-progress scroll animation before starting a new one
      if (this._cancelScroll) this._cancelScroll();

      return new Promise(resolve => {
        const startY = window.pageYOffset;
        const distance = targetY - startY;
        let startTime = null;
        let cancelled = false;

        this._cancelScroll = () => { cancelled = true; resolve(); };

        const easeOutCubic = t => 1 - Math.pow(1 - t, 3);
        const step = (timestamp) => {
          if (cancelled) return;
          if (!startTime) startTime = timestamp;
          const progress = Math.min((timestamp - startTime) / duration, 1);
          window.scrollTo(0, startY + distance * easeOutCubic(progress));
          if (progress < 1) requestAnimationFrame(step);
          else { this._cancelScroll = null; resolve(); }
        };
        requestAnimationFrame(step);
      });
    }

    // ── Final submit validation ────────────────────────────────────

    _validate() {
      const errors = [];
      const s = this.state;
      if (!s.variantId) errors.push('Please select a quantity.');
      if (!s.sellingPlanId) errors.push('Please select a delivery frequency.');
      if (s.selectionMode === 'pick' && s.selectedCoffees.length === 0) {
        errors.push('Pick at least one coffee for your rotation.');
      }
      if (!s.grind) errors.push('Please select a grind option.');
      return { valid: errors.length === 0, errors };
    }

    // ── Form sync ──────────────────────────────────────────────────

    _syncFormInputs() {
      const s = this.state;
      const setVal = (attr, val) => {
        const el = this.form.querySelector(`[${attr}]`);
        if (el) el.value = val || '';
      };

      setVal('data-form-variant', s.variantId);
      setVal('data-form-selling-plan', s.sellingPlanId);
      setVal('data-form-prop="subscription-mode"', s.selectionMode === 'dealers-choice' ? "Dealer's Choice" : 'Pick My Coffees');
      setVal('data-form-prop="brew-style"', s.brewStyle === 'all' ? 'All' : s.brewStyle.charAt(0).toUpperCase() + s.brewStyle.slice(1));
      setVal('data-form-prop="include-decaf"', s.includeDecaf ? 'Yes' : 'No');
      setVal('data-form-prop="include-buzzlite"', s.includeBuzzlite ? 'Yes' : 'No');
      setVal('data-form-prop="selected-coffees"', s.selectionMode === 'pick' ? s.selectedCoffees.join(', ') : "Dealer's Choice");
      setVal('data-form-prop="grind"', s.grind);
      setVal('data-form-prop="notes"', s.notes);
    }

    // ── Submit ─────────────────────────────────────────────────────

    async _handleSubmit() {
      this._clearErrors();
      const { valid, errors } = this._validate();

      if (!valid) {
        this._showErrors(errors);
        if (this.errorsWrap) this._scrollTo(this.errorsWrap);
        return;
      }

      this._syncFormInputs();

      const formData = new FormData(this.form);
      formData.append('sections', 'cart-drawer');

      this._setSubmitLoading(true);

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: new URLSearchParams(formData)
        });

        if (!res.ok) {
          const errData = await res.json().catch(() => ({}));
          throw errData;
        }

        document.documentElement.dispatchEvent(
          new CustomEvent('theme:cartchanged', {
            bubbles: true,
            cancelable: false,
            detail: { openDrawer: true }
          })
        );

        this._setSubmitSuccess();

      } catch (err) {
        const msg = (err && err.description) || 'Something went wrong. Please try again.';
        this._showErrors([msg]);
      } finally {
        this._setSubmitLoading(false);
      }
    }

    // ── UI state helpers ───────────────────────────────────────────

    _setSubmitLoading(loading) {
      if (!this.submitBtn) return;
      if (loading) {
        this.submitBtn.dataset.loading = '';
        this.submitBtn.setAttribute('aria-busy', 'true');
        this.submitBtn.textContent = 'Adding…';
      } else {
        delete this.submitBtn.dataset.loading;
        this.submitBtn.removeAttribute('aria-busy');
      }
    }

    _setSubmitSuccess() {
      if (!this.submitBtn) return;
      this.submitBtn.textContent = 'Added!';
      setTimeout(() => {
        if (this.submitBtn) {
          this.submitBtn.textContent = this.submitBtn.dataset.originalLabel || 'Start my subscription';
        }
      }, 3000);
    }

    _showErrors(errors) {
      if (!this.errorsWrap || !this.errorsList) return;
      this.errorsList.innerHTML = errors.map(e => `<li>${e}</li>`).join('');
      this.errorsWrap.hidden = false;
    }

    _clearErrors() {
      if (!this.errorsWrap || !this.errorsList) return;
      this.errorsList.innerHTML = '';
      this.errorsWrap.hidden = true;
    }
  }

  // ── Init ──────────────────────────────────────────────────────────

  function initBuilders() {
    document.querySelectorAll('[data-section-type="subscription-builder-wizard"]').forEach((el) => {
      if (!el.dataset.sbInit) {
        el.dataset.sbInit = '1';
        new SubscriptionBuilderWizard(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBuilders);
  } else {
    initBuilders();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const container = e.target.querySelector('[data-section-type="subscription-builder-wizard"]');
    if (container) {
      container.dataset.sbInit = '';
      initBuilders();
    }
  });

})();


  } catch(e) { console.error(e); }
})();
})();
